<lib-input-wrapper [ionItemWrap]="ionItemWrap">
    <ng-content *ngTemplateOutlet="toggleContent"></ng-content>
</lib-input-wrapper>

<ng-template #toggleContent>
    <ion-toggle
        (ionChange)="onChange($event)"
        [checked]="initialValue"
        [disabled]="disabled"
        [justify]="justify"
        mode="ios"
        color>
        <ng-content></ng-content>
    </ion-toggle>
</ng-template>
